export default __webpack_public_path__ + "static/media/ess.e0104c15.svg";